import "@assets/styles/common.loading.section.scss";

// TODO: add this hook
import { LoadingStatus } from "@/types";
import { Spin, SpinProps } from "antd";
import classNames from "classnames";

interface LoadingIconProps {
  text?: string;
}

const LoadingIcon: React.FC<LoadingIconProps> = (props: LoadingIconProps) => {
  return (
    <div className="loader">
      <div className="loader-spinner"></div>
      <div className="loader-text">{props.text}</div>
    </div>
  );
};

interface LoadingSectionProps {
  loadingStatus: boolean | LoadingStatus;
  loadingText: string;
  failureText?: string;
}

const LoadingSection: React.FC<LoadingSectionProps> = (
  props: LoadingSectionProps,
) => {
  // loading status is a LoadingStatus enum
  if ((props.loadingStatus as LoadingStatus) in LoadingStatus) {
    if (props.loadingStatus === LoadingStatus.loading) {
      return <LoadingIcon text={props.loadingText} />;
    } else {
      return <div>{props.failureText}</div>;
    }
  }
  // loading status is a boolean
  else {
    return props.loadingStatus && <LoadingIcon text={props.loadingText} />;
  }
};

export default LoadingSection;

export function LoadingMask({
  info,
  className,
  size = "default",
  indicator,
}: {
  info?: React.ReactNode;
  className?: string;
  size?: SpinProps["size"];
  indicator?: SpinProps["indicator"];
}) {
  return (
    <div
      className={classNames(
        "absolute top-0 left-0 w-full h-full",
        "flex flex-col items-center justify-center gap-6",
        className,
      )}
    >
      <Spin indicator={indicator} size={size} />
      {info && <div>{info}</div>}
    </div>
  );
}
